import React, {Fragment, useEffect, useState} from "react";
import AdvancedSearch from "./index";
import {useAdvancedSearchMCMutation} from "../../core/api/mc-state-api";

export default function AdvancedSearchMC() {

    return <AdvancedSearch useSearchHook={useAdvancedSearchMCMutation} />
}